import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const MoveToInboxSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default MoveToInboxSVG;
